export class SetParentPathAction {
  public static readonly type = '[Project/Storage/List] SetParentPathAction';
}
